import {
    GET_PRODUCT_REQUEST,
    GET_PRODUCT_SUCCESS,
    GET_PRODUCT_FAILED
} from '../../actions/product/get-product'

import {
    GET_STATISTICS_BY_PRODUCT_REQUEST,
    GET_STATISTICS_BY_PRODUCT_SUCCESS,
    GET_STATISTICS_BY_PRODUCT_FAILED
} from '../../actions/statistics/get-product-statistics'

import {
    GET_TIMELINE_BY_PRODUCT_REQUEST,
    GET_TIMELINE_BY_PRODUCT_SUCCESS,
    GET_TIMELINE_BY_PRODUCT_FAILED
} from '../../actions/statistics/get-product-timeline'

import {
    UPDATE_PRODUCT_REQUEST,
    UPDATE_PRODUCT_SUCCESS,
    UPDATE_PRODUCT_FAILED
} from '../../actions/product/update-product'

import {
    DELETE_PRODUCT_SUCCESS
} from '../../actions/product/delete-product'

import { UNPUBLISH_PRODUCT_SUCCESS } from './../../actions/product/unpublish-product'
import { PUBLISH_PRODUCT_SUCCESS } from './../../actions/product/publish-product'

const initialState = {
    product: null,
    textures: [],
    requesting: false,
    error: null,
    deletedProductId: null,
    statistics: null,
    timeline: null,
    statisticsError: null,
    statisticsRequesting: false,
    updateModelRequesting: false
}

export const editProduct = (state = initialState, action) => {
    switch (action.type) {
        case GET_PRODUCT_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                product: null,
                error: null
            })
        case GET_PRODUCT_FAILED:
            return Object.assign({}, state, {
                product: null,
                requesting: false,
                error: action.error
            })
        case GET_PRODUCT_SUCCESS:
            return Object.assign({}, state, {
                product: action.payload.data.payload,
                requesting: false,
            })
        case DELETE_PRODUCT_SUCCESS:
            return Object.assign({}, state, {
                product: action.payload.data.payload,
                requesting: false,
                error: null,
                deletedProductId: action.payload.data.payload._id
            })
        case UPDATE_PRODUCT_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                product: null,
                error: null
            })
        case UPDATE_PRODUCT_SUCCESS:
            return Object.assign({}, state, {
                product: action.payload.data.payload,
                requesting: false,
                error:null
            })
        case UPDATE_PRODUCT_FAILED:
            return Object.assign({}, state, {
                requesting: false,
                error: action.error
            })
        case GET_STATISTICS_BY_PRODUCT_REQUEST:
            return Object.assign({}, state, {
                statisticsRequesting: true
            })
        case GET_STATISTICS_BY_PRODUCT_SUCCESS:
            return Object.assign({}, state, {
                statistics: action.payload.data.payload,
                statisticsError: null,
                statisticsRequesting: true
            })
        case GET_STATISTICS_BY_PRODUCT_FAILED:
            return Object.assign({}, state, {
                statisticsError: action.error,
                statisticsRequesting: true
            })
        case GET_TIMELINE_BY_PRODUCT_REQUEST:
            return Object.assign({}, state, {
                timelineRequesting: true
            })
        case GET_TIMELINE_BY_PRODUCT_SUCCESS:
            return Object.assign({}, state, {
                timeline: action.payload.data.payload,
                timelineError: null,
                timelineRequesting: true
            })
        case GET_TIMELINE_BY_PRODUCT_FAILED:
            return Object.assign({}, state, {
                timelineError: action.error,
                timelineRequesting: true
            })
        case UNPUBLISH_PRODUCT_SUCCESS:
            return Object.assign({}, state, {
                product: action.payload.data.payload
            })
        case PUBLISH_PRODUCT_SUCCESS:
            return Object.assign({}, state, {
                product: action.payload.data.payload
            })
        default:
            return state
    }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/product/edit-product.js